import {initializeApplePay} from "p360wsc-js/payments/apple-pay";
import {initializeGooglePay} from "p360wsc-js/payments/google-pay";
import {appendQueryParameterToCurrentUrl} from "./functions";

function parseErrorsFromResponse(text) {
    try {
        const data = JSON.parse(text);
        const errors = data.errors.errors.reduce(function(acc, message) {
            return acc + message;
        }, '');

        return errors;
    } catch (e) {
        return 'Unknown error.';
    }
}

function renderErrorFromResponse(response, validationElement) {
    validationElement.removeClass('hidden');

    const validationMessage = parseErrorsFromResponse(response.responseText);
    const errorBody = $('<div><div class="pt-6"><button type="button" class="btn btn--primary">' + validationElement.data('ok-label') + '</button></div></div>')
        .prepend(validationMessage)
        .html();
    validationElement.html(errorBody);
    validationElement.find('button').one('click', function(e) {
        validationElement.addClass('hidden');
    });
}

$(document).on('change', 'input[data-product-id].js-menu-decision, input[data-custom-menu-id].js-menu-decision', function(e) {
    const $button = $(e.target);
    const $form = $button.closest('form');
    const productId = $button.data('productId');
    const customMenuId = $button.data('custom-menu-id');

    if (productId) {
        const url = new URL($form.attr('action'), location.href);
        url.searchParams.set('productId', productId);
        $form.attr('action', url.toString());
    }

    if (customMenuId) {
        const customMenuButton = $form.find('.js-choose-custom-menu');
        const customMenuUrl = new URL(customMenuButton.data('app-widget-url'));
        customMenuUrl.searchParams.append(
            'selected', (new URL($form.get(0).action)).searchParams.get('productVariantId')
        );
        const selectedPastry = Array.from($form.get(0).querySelectorAll(':checked')).filter(el => el.name.match(/pastry/)).shift();
        if (selectedPastry) {
            customMenuUrl.searchParams.append(
                'selected_pastry',
                selectedPastry.value
            );
        }
        customMenuUrl.searchParams.append('forwardedFrom', 'baguette');
        customMenuButton.show().data('app-widget-url', customMenuUrl.toString());
        $form.find('.js-choose-menu').hide();
    } else {
        $form.find('.js-choose-custom-menu').hide();
        $form.find('.js-choose-menu').show();
    }

    if (e.target.checked) {
        $form.find('button.js-choose-menu').removeAttr('disabled').removeClass('disabled');
    }
});

$(document).on('submit', '.app-product-adding-to-cart:not(.product-config-form)', function(e) {
    const $form = $(this);
    const redirectUrl = $form.data('redirect') || window.location.href;
    const href = $form.attr('action');
    const validationElement = $('#sylius-cart-validation-error');

    e.preventDefault();
    $.ajax({
        type: 'POST',
        url: href,
        dataType: 'json',
        data: $form.serialize(),
        error: function(response) {
            renderErrorFromResponse(response, validationElement);
            $form.removeClass('loading');
        },
        success: function(response) {
            validationElement.addClass('hidden');
            if (response && response.location) {
                window.location.href = response.location;
            } else if (redirectUrl === window.location.href) {
                window.location.reload();
            } else {
                window.location.href = redirectUrl;
            }
        }
    });
});

$(document).on('click', '.configured-product-order', function(e) {
    e.preventDefault();
    const $this = $(this);
    const href = $this.attr('href');
    const validationElement = $('#sylius-cart-validation-error');

    $.ajax({
        type: 'GET',
        url: href,
        error: function(response) {
            renderErrorFromResponse(response, validationElement);
        },
        success: function() {
            window.location.reload();
        }
    });
});

$(document).on('click', '.configured-product-delete', function(e) {
    e.preventDefault();
    var confirmationModal = $('#confirmation-modal');
    if (confirmationModal.length) {
        const href = $(this).attr('href');
        confirmationModal.confirmationListeners(function() {
            $('#confirmation-modal-dimmer').show();
            $(this).modal('hide');
            const validationElement = $('#sylius-cart-validation-error');
            $.ajax({
                type: 'DELETE',
                url: href,
                error: function(response) {
                    renderErrorFromResponse(response, validationElement);
                },
                success: function() {
                    window.location.reload();
                }
            });
        });
        confirmationModal.modal('show');
    }
});

$(document).on('click', '.app-cart-remove-button', function() {
    const $button = $(this);
    const data = {
        _csrf_token: $button.data('csrf-token')
    };

    $.ajax({
        type: 'DELETE',
        url: $button.data('url'),
        data: data
    }).done(function(response) {
        if (response && response.location) {
            location.href = response.location;
        } else {
            location.reload();
        }
    });
});

$(document).on('click', '.app-cart-remove-order-item-button', function() {
    const $button = $(this);
    $.ajax({
        type: 'DELETE',
        url: $button.data('url'),
    }).done(function() {
        location.reload();
    });
});

$(document).on('change', '[name="sylius_add_to_cart[cartItem][pastry]"]', function(e) {
    if (e.target.checked) {
        $(this).parents('form').find('button.js-choose-pastry').removeAttr('disabled').removeClass('disabled');
    }
});

let cartTimer = null;
$(document).on('click', '.app-cart-quantity-button', function () {
    let $_this = $(this);
    let $_form = $_this.parents('form');
    let plus = ($_this.data('cart-count') === 'cartPlus');
    if (plus) {
        let inVal = parseInt($_this.prev().val());
        $_this.prev().val(inVal + 1);
    } else {
        let inVal = parseInt($_this.next().val());
        if ($_this.next().val() > 1) {
            $_this.next().val(inVal - 1);
        } else {
            return;
        }
    }

    clearTimeout(cartTimer);
    // only send the ajax request if 2 seconds passed
    cartTimer = setTimeout(function() {updateCartQuantity($_form)}, 1000);
});

function updateCartQuantity($_form) {
    cartTimer = null;
    $.ajax({
        type: "POST",
        url: $_form.attr('action'),
        data: $_form.serialize(),
    }).done(function(response) {
        if (response.location) {
            window.location.href = response.location;
        } else {
            window.location = window.location.href;
        }
    });
}

var idleTime = 0;
var idleInterval = null;
var cartInactiveTimeout = 0;
function timerIncrement() {
    idleTime = idleTime + 1;
    if (idleTime === parseInt(cartInactiveTimeout.substring(0, cartInactiveTimeout.length - 1))) {
        $('.modal-cart-inactive').addClass('modal--active');
    }
}
$(function() {
    if($('.modal-cart-inactive').length) {
        cartInactiveTimeout = $('.modal-cart-inactive').data('timeout');
        if(cartInactiveTimeout.length < 2)
            return;
        idleInterval = setInterval(timerIncrement, 1000);

        function resetTime() {
            idleTime = 0;
        }

        $(this).mousemove(resetTime);
        $(this).keypress(resetTime);
        $(this).scroll(resetTime);
    }
});

$(document).on('click', '.modal-cart-inactive__close', function() {
    clearInterval(idleInterval);
    $('.modal-cart-inactive').removeClass('modal--active');
});

initializeApplePay();


function isGooglePayPaymentMethodChosen() {
    return $('input[type="radio"][name^="checkout[payment][payments]"]:checked').parents('[data-google-pay-payment-method]').length ||
        $('input[type="radio"][name^="sylius_checkout_select_payment[payments]"]:checked').parents('[data-google-pay-payment-method]').length;
}

$(document).ready(() => {
    const googlePayChoice = $('[data-google-pay-payment-method]');
    const googlePayTrigger = $('.google-pay-trigger');
    let deferred, config;
    if (googlePayTrigger.length && googlePayTrigger.data('google-pay-payload')) {
        config = googlePayTrigger.data('google-pay-config');
        deferred = new Promise(resolve => {
            googlePayTrigger.on('click', e => {
                e.preventDefault();
                resolve(googlePayTrigger.data('google-pay-payload'));
            });
        });
    }
    if (googlePayChoice.length && googlePayChoice.data('google-pay-config')) {
        config = googlePayChoice.data('google-pay-config');
        if (googlePayChoice.data('google-pay-form-payload')) {
            deferred = new Promise(resolve => {
                googlePayChoice.parents('form').on('submit', () => {
                    if (isGooglePayPaymentMethodChosen()) {
                        resolve(googlePayChoice.data('google-pay-form-payload'));
                        return false;
                    }
                });
            });
        } else {
            deferred = new Promise(resolve => {
                const checkoutForm = $('form[name="checkout"]');
                const onSubmit = (e) => {
                    if (isGooglePayPaymentMethodChosen()) {
                        e.preventDefault();
                        $.post({
                            url: checkoutForm.prop('action'),
                            data: checkoutForm.serialize()
                        }).then(response => {
                            if (response.status) {
                                checkoutForm.removeClass('loading');
                                resolve(response);
                            } else if (response.preloadKey) {
                                window.location.href = appendQueryParameterToCurrentUrl('_preload', response.preloadKey);
                            } else {
                                window.location.reload();
                            }
                        }).catch(() => window.location.reload());
                        return false;
                    }
                };
                checkoutForm.get(0).addEventListener('submit', onSubmit);
            });
        }
    }
    if (deferred) {
        initializeGooglePay(
            {
                paymentMethodChoice: googlePayChoice || undefined,
                triggerButton: googlePayTrigger || undefined,
                modals: $('.modals')
            },
            config,
            deferred
        );
    }
});
